import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AddDoctor = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        comp_name: "",
        emp_code: "",
        doj: "",
        mobile: "",
        email: "",
        pay_model: "Fixed"
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("jwt_token");

        try {
            const response = await fetch(`${API_BASE_URL}api/createDoctor`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();
            if (response.ok) {
                alert("Doctor added successfully!");
                navigate("/doctors_list");
            } else {
                alert(result.message || "Error adding doctor");
            }
        } catch (error) {
            console.error("Submit Error:", error);
        }
    };

    return (
        <div className="wrapper">
            <Sidebar />
            <main className="main-content content-page">
                <Navbar />
                <div className="content-inner container-fluid pt-4">
                    <div className="card p-4">
                        <h4 className="mb-4">Add New Doctor</h4>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Doctor Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="comp_name"
                                        value={formData.comp_name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">BMID (Employee Code)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="emp_code"
                                        value={formData.emp_code}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Date of Joining</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="doj"
                                        value={formData.doj}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Mobile</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="mobile"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Payment Model</label>
                                    <select
                                        className="form-control"
                                        name="pay_model"
                                        value={formData.pay_model}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="Fixed">Fixed</option>
                                        <option value="Case_Based">Case Base</option>
                                        <option value="Target">Target</option>
                                        <option value="Minimum_Guarantee">Minimum Guarantee</option>
                                    </select>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-success mt-3">Add Doctor</button>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default AddDoctor;
